import { ApplicationExceptionHandler, errorHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ShippingTermsService } from './shipping-terms.service';
import { ShippingTermsDTO } from './dto/shipping-terms.dto';
import { ShippingTermsResponseModel, AllShippingTermsResponseModel, ShippingTermsDropDownResponseModel } from '@gtpl/shared-models/masters';
import { ShippingTermsRequest } from './dto/shipping-terms.requests';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
// import { UserRequestDto } from '@gtpl/shared-models/common-models';

@ApiTags('shipping-terms')
@Controller('shipping-terms')
export class ShippingTermsController {
    constructor(
        private shippingTermsService: ShippingTermsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
   /**
     * creates or updates a value of shippingTerms
     * @param shippingTermsDto shippingTerms DTO
     * @returns shippingTermsResponse
     */
    @Post('/createShippingTerms')
    async createShippingTerms(@Body() shippingTermsDTO:ShippingTermsDTO,isUpdate:boolean=false,@Req() request:Request): Promise<ShippingTermsResponseModel> {
        try {
            // console.log(shippingTermsDTO);
            return await this.shippingTermsService.createShippingTerms(shippingTermsDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ShippingTermsResponseModel, error)
        }
    }

    /**
     * creates or updates a value of shippingTerms
     * @param shippingTermsDto shippingTerms DTO
     * @returns shippingTermsResponse
     */
    @Post('/updateShippingTerms')
    async updateShippingTerms(@Body() shippingTermsDTO: ShippingTermsDTO,@Req() request:Request): Promise<ShippingTermsResponseModel> {
        try {
        return await this.shippingTermsService.createShippingTerms(shippingTermsDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ShippingTermsResponseModel, error)
        }
    }

      /**
     * gets all the Value of shippingTerms
     * @returns AllValue shippingTermsResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */
    @Post('/getAllShippingTerms')
    async getAllShippingTerms(@Body() req?:UserRequestDto): Promise<AllShippingTermsResponseModel> {
        try {
        return await this.shippingTermsService.getAllShippingTerms(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllShippingTermsResponseModel, error)
        }
    }

    @Post('/getAllActiveShippingTerms')
  async getAllActiveShippingTerms(@Req() request: Request): Promise<AllShippingTermsResponseModel> {
      try {
          return await this.shippingTermsService.getAllActiveShippingTerms();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(AllShippingTermsResponseModel, error)
      }
  }

     /**
     * Activate Or De-Activate Value ShippingTerms
     * @param getSingleShippingTerms ShippingTermsResponseModel 
     * @returns Value ShippingTerms
     */
    @Post('/activateOrDeactivateShippingTerms')
    async activateOrDeactivateShippingTerms(@Body() shippingTermsReq: ShippingTermsRequest): Promise<ShippingTermsResponseModel> {
        try {
            return await this.shippingTermsService.activateOrDeactivateShippingTerms(shippingTermsReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ShippingTermsResponseModel, err);
        }
    }
    @Post('/getShippingTermsById')
    async getShippingTermsById(@Body() shippingTermsReq: ShippingTermsRequest): Promise<ShippingTermsResponseModel> {
        try {
            return await this.shippingTermsService.getActiveShippingTermsById(shippingTermsReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ShippingTermsResponseModel, err);
        }
    }

    @Post('/getAllShippingTermsDropDown')
    async getAllShippingTermsDropDown(): Promise<ShippingTermsDropDownResponseModel> {
        try {
        return await this.shippingTermsService.getAllShippingTermsDropDown();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ShippingTermsDropDownResponseModel, error)
        }
    }
}


